module.exports = __webpack_public_path__ + "static/media/WoodPanelType1.189ea6ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WoodPanelType1.png
// module id = 1189
// module chunks = 0